// AxiosBuilder.js
import axios from 'axios';

const errorHandler = (error) => {
    // No response = network/protocol failure (DNS, CORS, HTTP2, offline). Don't mask it
    // with a TypeError on error.response.status — let the real error through.
    if (error.response && error.response.status === 401) {
        window.top.location.reload();
    }

    // Otherwise throw error
    return Promise.reject({error});
};

const successHandler = (response) => {
    // If needed you can get status codes e.g. with response.status

    // Return response
    return response;
};

axios.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

export default axios;
